/**
 * * Модель оценки времени для исполнителя
 */
export class PerformerEstimatedModel {
  /**ID исполнителя */
  Id!: number;
  /**Имя */
  FirstName!: string;
  /**Фамилия */
  LastName!: string;
  /**Отчество */
  MiddleName!: string;
  /**Цвет аватарки */
  AvatarColor!: string;
  /**Фото */
  Foto!: string;
  /**Оценка */
  Estimate!: number;
  /**Время установки оценки */
  DateUpsert?: Date;
  /**Редактирование */
  IsEdit?: boolean;

  constructor(obj?: Partial<PerformerEstimatedModel>) {
    Object.assign(this, obj);
  }
}
